<template>
  <router-link :class="{ active: isActive() }" :to="tab.route">
    {{ $t(tab.title) }}
  </router-link>
</template>
<script>
// @vuese
// Liniki zakładek
// @group Components
export default {
  props: {
    // Zakładka
    tab: {
      type: Object,
      required: true
    }
  },
  methods: {
    // @vuese
    // Sprawdza czy link jest aktywny
    isActive() {
      return this.tab && this.tab.route && this.$route.name === this.tab.route.name;
    }
  }
};
</script>
